import { render, staticRenderFns } from "./SidebarNavLabel.vue?vue&type=template&id=3716e1c6&"
import script from "./SidebarNavLabel.vue?vue&type=script&lang=js&"
export * from "./SidebarNavLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/SidebarNavLabel.vue
// module id = null
// module chunks = 